import AppDashboard from '../AppDashboard';
import MigrationScreen from '../../components/admin/MigrationScreen';

const AdminMigrationPage = props => {
  return (
    <AppDashboard>
      <MigrationScreen />
    </AppDashboard>
  );
};

export default AdminMigrationPage;